import React, { useState, useEffect } from "react"

import PropTypes from "prop-types"
import classNames from "classnames"
import RangeSlider from "./range-slider"
import CurrentRefinements from "./current-refinements"
import Checkboxes from "./checkboxes"
import { breakpoints } from "../../utils"
import { useMenu } from 'react-instantsearch';
import FilterComponent from "./filter-component"
import {  useRefinementList } from 'react-instantsearch';


function DefaultRefinement({ attribute, defaultRefinement }) {
  const { refine, items } = useRefinementList({ attribute });

  useEffect(() => {
    if (items.length > 0) {
      // Apply default refinements only once
      defaultRefinement.forEach((value) => {
        const item = items.find((item) => item.label === value);
        if (item && !item.isRefined) {
          refine(value);
        }
      });
    }
  }, [items, refine, defaultRefinement]);

  return null; // Nothing rendered; this is for refinement only
}
function DefaultRefinementSingle({ attribute, defaultRefinement }) {
  const { refine, items } = useRefinementList({ attribute });

  useEffect(() => {
    if (items.length > 0) {
      // Apply default refinements only once
        const item = items.find((item) => item.label === defaultRefinement);
        if (item && !item.isRefined) {
          refine(defaultRefinement);
        }
    }
  }, [items, refine, defaultRefinement]);

  return null; // Nothing rendered; this is for refinement only
}

function VirtualRefinement({ attribute, defaultRefinement }) {
  useMenu({ attribute, defaultRefinement });
  return null;
}

function Filters({ withQuery, withRangeFilter, withVeet, withHefficacy, withAppCategory, withAppCategoryVal, withBackTo, withClear, defaultAttribute} ){

  const [filtersVisible, setFiltersVisible] = useState( window.matchMedia(breakpoints.desk).matches );


   return( <div className="search__filters">
    {console.log(withAppCategory)} {console.log( withAppCategoryVal )}
        <div className="search__filters__header">
            {withBackTo
                    ? <a className="search__back" href={withBackTo.url}>
                        <svg><use xlinkHref="#solid-arrow-left" /></svg>
                            Back <span className="hide--palm">to categories</span>
                    </a>
                    : null
            }
            <button
                className="search__filters-toggle"
                onClick={() => setFiltersVisible( !filtersVisible )}
            >
                <div>
                    <span className="flex-group">
                        <svg className="push--right"><use xlinkHref="#filter-icon" /></svg>
                        Filters
                    </span>
                    {filtersVisible
                        ? <svg><use xlinkHref="#chevron-up" /></svg>
                        : <svg><use xlinkHref="#chevron-down" /></svg>}
                </div>
            </button>
        </div>
        <div className={classNames("search__filters__container", { "is-active": filtersVisible })}>
         
            <FilterComponent wrapper={ <CurrentRefinements
                withQuery={withQuery}
                defaultAttribute={defaultAttribute}
                withClear
            />}
            heading="Filter by"
           withClear
            withQuery={withQuery}  

            />
            <VirtualRefinement attribute="enabled" defaultRefinement={"true"} />

              {withVeet
                ? <VirtualRefinement attribute="veetApproved" defaultRefinement={"true"} />
                : null
            }

            {withVeet
                ? <VirtualRefinement attribute="veetApproved" defaultRefinement={"true"} />
                : null
            }
            {withHefficacy
                ? <VirtualRefinement attribute="highEfficacy" defaultRefinement={"true"} />
                : null
            }
            {withAppCategory
                ? <VirtualRefinement attribute="applicationCategory" defaultRefinement={withAppCategoryVal} />
                : null
            }
           
           
            {withRangeFilter
                ? <FilterComponent wrapper={<Checkboxes
                    attributeName="productCategories"
                />}
                 heading="Product Categories" 
                 withExpander
                 />
                : null
            }
            <FilterComponent wrapper={<Checkboxes
                attributeName="applicationCategories"
            />}
             heading="Application"
             withExpander

            />

            <FilterComponent wrapper={<Checkboxes
                attributeName="ostendoInstallationMethod"
            />}
             heading="Installation Method"
             withExpander
            />

            <FilterComponent wrapper={ <Checkboxes
                attributeName="ostendoTrimColour"
            />}
            heading="Trim Colour"
             withExpander
            />

            <FilterComponent wrapper={<RangeSlider
                attributeName="ostendoCutoutSize"
                unit="mm"
            />}
            heading="Cutout Size"
            withExpander
            />

             <FilterComponent wrapper={<Checkboxes
                attributeName="ostendoIpRating"
            />}
            heading="IP Rating"
            withExpander
            />

            <FilterComponent wrapper={<Checkboxes
                attributeName="ostendoColourTemperature"
            />}
            heading="Colour Temperature"
            withExpander
            />

            <FilterComponent wrapper={<Checkboxes
                attributeName="highEfficacy"
                replaceLabel="True"
            />}
            heading="High Efficacy"
            withExpander
            />

             <FilterComponent wrapper={<RangeSlider
                attributeName="ostendoLumenOutput"
                unit="lm"
            />}
            heading="Lumen Output"
            withExpander
            />

             <FilterComponent wrapper={<RangeSlider
                attributeName="ostendoSystemPower"
                unit="W"
            />}
            heading="Power Output"
            withExpander
            />

            <FilterComponent wrapper={<RangeSlider
                attributeName="ostendoSystemPower"
                unit="W"
            />}
            heading="Power Output"
            withExpander
            />

            <FilterComponent wrapper={<Checkboxes
                attributeName="ostendoDimmingOption"
            />}
            heading="Dimming Option"
            withExpander
            />

            <FilterComponent wrapper={<Checkboxes
                attributeName="ostendoAccessories"
            />}
            heading="Accessories"
            withExpander
            />

              {withVeet
                ? null
                : <FilterComponent wrapper={<Checkboxes
                    attributeName="veetApproved"
                    replaceLabel="VEU/IPART Approved"
                />}
                heading="Accreditation"
                withExpander
            />
            }

             <FilterComponent wrapper={<Checkboxes
                    attributeName="applicationCategory"
                />}
                heading="Application Categories"
                withExpander
            />
             
        </div>
    </div>
    )}

Filters.propTypes = {
 withQuery: PropTypes.bool,
	withRangeFilter: PropTypes.bool,
	withVeet: PropTypes.bool,
    withHefficacy: PropTypes.bool,
    withAppCategory: PropTypes.bool,
    withAppCategoryVal:  PropTypes.string,
	withBackTo: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.shape({
			url: PropTypes.string,
			text: PropTypes.string,
		}),
	]),
	defaultAttribute: PropTypes.string,
};
Filters.defaultProps = {
    withQuery: false,
	withRangeFilter: false,
	withVeet: false,
    withHefficacy: false,
    withAppCategory: false,
	withBackTo: false,
	defaultAttribute: null,

};
export default Filters